// import "./pop-up.css";


// interface PopupProps {
//     isOpen: boolean;
//     children: React.ReactNode;
// }

// export default function Popup({ isOpen, children }: PopupProps) {
//     if (!isOpen) return null;
//     return (
//         <div className="pop-up">
//             {children}
//         </div>
//     );
// }

import "./pop-up.css";

interface PopupProps {
    isOpen: boolean;
    children: React.ReactNode;
    position?: "center" | "top-right"; // Optional prop to choose position
}

export default function Popup({ isOpen, children, position = "top-right" }: PopupProps) {
    if (!isOpen) return null;
    
    return (
        <div className={`pop-up pop-up-${position}`}>
            {children}
        </div>
    );
}